import { render, staticRenderFns } from "./WizardProjectType.vue?vue&type=template&id=2d19f741&scoped=true"
import script from "./WizardProjectType.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardProjectType.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WizardProjectType.vue?vue&type=style&index=0&id=2d19f741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d19f741",
  null
  
)

export default component.exports